import { useForm, SubmitHandler } from "react-hook-form";
import { Modal, Button, Box, Typography } from "@mui/material";
import * as React from "react";
import { windowCloseIcon } from "@cds/core/icon";
import { CdsIcon } from "@bb-vendure/admin-ui/react";
import { CustomsClearanceState, ICustomsClearance } from "./types";
import { useEffect, useState } from "react";
import useGetCustomsClearance from "./graphql/Get-Customs-Clearance";
import useChangeCustomsClearacneState from "./graphql/Change-Customs-Clearance-State";
import { colorByState } from "./helper";
import { EmptyIcon } from "./TableSearch";
import useCheckOrder from "./graphql/check-order";

const CustomsClearanceModal = ({
  openModal,
  setOpenModal,
  orderId,
  setDisable,
}: {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  orderId: string;
  setDisable: (yes: boolean) => void;
}) => {
  const styles = {
    modalStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 1400,
      minHeight: "45rem",
      bgcolor: "background.paper",
      boxShadow: 24,
      pt: 2,
      px: 4,
      pb: 3,
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
    },
  };

  const [currentOrderId, setCurrentOrderId] = useState<string>(orderId);
  const { data, loading, error, refetch } = useGetCustomsClearance(
    currentOrderId,
    true
  );
  const { data: previousOrderData, refetch: refetchCheckPreviousOrder } =
    useCheckOrder((+currentOrderId - 1).toString());
  const { data: nextOrderData, refetch: refetchCheckNextOrder } = useCheckOrder(
    (+currentOrderId + 1).toString()
  );
  const [changeCustomsClearanceState] = useChangeCustomsClearacneState();
  const [customsClearance, setCustomsClearance] = useState<
    ICustomsClearance | undefined
  >(undefined);
  const [selectedFile, setSelectedFile] = useState("");

  useEffect(() => {
    if (data) {
      const result = (data as any).customsClearance;
      if (result) {
        setCustomsClearance(result);
        setSelectedFile(
          result.files && result.files.length > 0 ? result.files[0].source : ""
        );
      } else {
        setDisable(true);
      }
    }
  }, [data]);

  useEffect(() => {
    refetch({
      id: currentOrderId,
    });
    refetchCheckPreviousOrder({
      input: (+currentOrderId - 1).toString(),
    });
    refetchCheckNextOrder({
      input: (+currentOrderId + 1).toString(),
    });
  }, [currentOrderId]);

  if (!customsClearance) {
    if (loading) {
      return (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
          style={{
            minHeight: "50rem",
          }}
        >
          <Box sx={{ ...styles.modalStyle }}>Loading....</Box>
        </Modal>
      );
    } else {
      return (
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
          style={{
            minHeight: "50rem",
          }}
        >
          <Box sx={{ ...styles.modalStyle }}>
            No customs clearance is provided
          </Box>
        </Modal>
      );
    }
  }

  function changeState(nextState: string) {
    changeCustomsClearanceState({
      id: customsClearance?.id,
      nextState: nextState,
    }).then((newData) => {
      const result = (newData as any).customsClearance;
      if (result) {
        setCustomsClearance(result);
        setSelectedFile(
          result.files && result.files.length > 0 ? result.files[0].source : ""
        );
      }
    });
  }

  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-describedby="child-modal-description"
      style={{
        minHeight: "50rem",
      }}
    >
      <Box sx={{ ...styles.modalStyle }}>
        <div className="flex" style={styles.header}>
          <h2
            style={{
              marginTop: "0",
              fontWeight: "600",
            }}
          >
            Customs Clearance
          </h2>
          <Button onClick={() => setOpenModal(false)}>
            <CdsIcon icon={windowCloseIcon} size="lg" />
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            paddingTop: "16px",
            padding: "16px 0px 16px 0px",
          }}
        >
          <p style={{ marginRight: "16px", marginTop: "0" }}>
            Order Id : {currentOrderId}
          </p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <p style={{ marginTop: "0" }}>Customs Clearance Status :</p>
            <span
              className={`button ${colorByState(customsClearance.state)}`}
              style={{
                marginLeft: "8px",
                borderRadius: "24px",
                cursor: "default",
                padding: "0px 8px 0px 8px",
              }}
            >
              {customsClearance.state}
            </span>
          </div>
          {customsClearance.files && customsClearance.files.length === 0 && (
            <div
              style={{
                marginLeft: "30px",
              }}
            >
              No customs clearance file is provided !
            </div>
          )}
        </div>
        <div>
          {customsClearance.files && customsClearance.files?.length > 0 ? (
            <iframe
              style={{
                width: "100%",
                minHeight: "30rem",
              }}
              src={selectedFile}
            ></iframe>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: "30rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <EmptyIcon span={3} size="100px" />
            </div>
          )}
        </div>
        <div
          style={{
            overflowX: "auto",
            display: "block",
            whiteSpace: "nowrap",
          }}
        >
          {customsClearance.files?.map((file, key) => (
            <div
              key={key}
              style={{
                width: "4rem",
                height: "5rem",
                border: "2px solid",
                marginRight: "8px",
                display: "inline-block",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                overflow: "hidden",
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedFile(file.source);
              }}
            >
              <div
                style={{
                  position: "relative",
                }}
              >
                <img
                  style={{
                    objectFit: "contain",
                    width: "4rem",
                    height: "5rem",
                  }}
                  src={file.preview}
                  alt="test"
                />
                <p
                  style={{
                    position: "absolute",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  {file.name}
                </p>
              </div>
            </div>
          ))}
          {customsClearance.files && customsClearance.files.length === 0 && (
            <div
              style={{
                height: "5rem",
              }}
            ></div>
          )}
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "end",
            columnGap: "8px",
          }}
        >
          <button
            style={{
              width: "9rem",
              textAlign: "center",
              justifyContent: "center",
            }}
            disabled={
              previousOrderData !== undefined &&
              !(previousOrderData as any).order
            }
            onClick={() => {
              setCurrentOrderId((+currentOrderId - 1).toString());
            }}
            className="button primary"
          >
            Previous Order
          </button>
          <button
            style={{
              width: "9rem",
              textAlign: "center",
              justifyContent: "center",
            }}
            className="button primary"
            disabled={
              nextOrderData !== undefined && !(nextOrderData as any).order
            }
            onClick={() => {
              setCurrentOrderId((+currentOrderId + 1).toString());
            }}
          >
            Next Order
          </button>
          <button
            style={{
              width: "9rem",
              textAlign: "center",
              justifyContent: "center",
            }}
            disabled={customsClearance.state == CustomsClearanceState.Reviewed}
            className="button primary"
            onClick={() => {
              changeState(CustomsClearanceState.Reviewed);
            }}
          >
            Confirm
          </button>
          <button
            style={{
              width: "9rem",
              textAlign: "center",
              justifyContent: "center",
            }}
            disabled={
              customsClearance.state == CustomsClearanceState.RequestSupplement
            }
            className="button primary"
            onClick={() => {
              changeState(CustomsClearanceState.RequestSupplement);
            }}
          >
            Request supplementing
          </button>
        </div>
      </Box>
    </Modal>
  );
};

export default CustomsClearanceModal;
